import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import cx from 'classnames2';
import React from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import styles from './ReorderableBlockList.scss';
import { ReorderableBlockListItem } from './ReorderableBlockListItem';
export var ReorderableBlockList = /*#__PURE__*/function (_React$Component) {
  _inherits(ReorderableBlockList, _React$Component);

  var _super = _createSuper(ReorderableBlockList);

  function ReorderableBlockList() {
    var _this;

    _classCallCheck(this, ReorderableBlockList);

    _this = _super.apply(this, arguments);

    _this.onDragEnd = function (result) {
      var destination = result.destination,
          source = result.source,
          draggableId = result.draggableId;

      if (!destination) {
        return;
      }

      if (destination.index === source.index) {
        return;
      }

      _this.props.onDragEnd(source.index, destination.index, draggableId);
    };

    return _this;
  }

  _createClass(ReorderableBlockList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dataTest = _this$props.dataTest,
          children = _this$props.children;
      return React.createElement(DragDropContext, {
        onDragEnd: this.onDragEnd
      }, React.createElement(Droppable, {
        droppableId: "droppable"
      }, function (provided, _ref) {
        var isDraggingOver = _ref.isDraggingOver;
        return React.createElement("div", Object.assign({}, provided.droppableProps, {
          ref: provided.innerRef,
          "data-test": dataTest,
          className: cx(styles.container, isDraggingOver && styles.active)
        }), React.Children.map(children, function (child, index) {
          return React.cloneElement(child, {
            index: index,
            dataTest: "list-item-".concat(index),
            isDraggingOver: isDraggingOver
          });
        }), provided.placeholder);
      }));
    }
  }]);

  return ReorderableBlockList;
}(React.Component);
ReorderableBlockList.Item = ReorderableBlockListItem;